import type { ReactNode } from "react";
import type { Poste } from "models";
import type { FieldValues, FieldPath } from "react-hook-form";
import { useController } from "react-hook-form";
import type { ControlledInput } from "utils";
import { FormControl, FormHelperText } from "@mui/material";
import { PosteAutoComplete } from "./PosteAutoComplete";

interface ControlledPosteAutoCompleteProps<
  T extends FieldValues,
  Name extends FieldPath<T>,
> extends ControlledInput<T, Name> {
  label?: string;
  postes: Array<Poste>;
  disabled?: boolean;
  defaultHelperText?: string;
}

export function ControlledPosteAutoComplete<T extends FieldValues, Name extends FieldPath<T>>({
  name,
  control,
  label,
  defaultValue,
  rules,
  postes,
  disabled = false,
  defaultHelperText,
}: Readonly<ControlledPosteAutoCompleteProps<T, Name>>): ReactNode {
  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController({ name, control, rules, defaultValue });

  return (
    <FormControl fullWidth disabled={disabled}>
      <PosteAutoComplete label={label} value={value} onChange={onChange} postes={postes} />
      {(error?.message ?? defaultHelperText) != null && (
        <FormHelperText error={error != null}>{error?.message ?? defaultHelperText}</FormHelperText>
      )}
    </FormControl>
  );
}
